module.exports = __webpack_public_path__ + "static/media/icons8-brochure.9d1a1c95.svg";